import { useEffect, useState } from "react";
import { ghostBtnClass, inputClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { listWaitingInspectionOrders, type WaitingInspectionOrder } from "@/lib/manufacturing/builderAssistantClient";

export function BuilderAssistantOrderPicker({
  busy,
  onPick,
  onClose,
}: {
  busy: boolean;
  onPick: (order: WaitingInspectionOrder) => void;
  onClose: () => void;
}) {
  const [orders, setOrders] = useState<WaitingInspectionOrder[]>([]);
  const [query, setQuery] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void listWaitingInspectionOrders().then((res) => {
      if (!res.ok) {
        setError(res.error);
        return;
      }
      setOrders(res.data.orders);
    });
  }, []);

  const needle = query.trim().toLowerCase();
  const shown = orders.filter((order) =>
    [order.serial, order.long_serial, order.model, order.size].join(" ").toLowerCase().includes(needle),
  );

  return (
    <div className="space-y-2 rounded-md border border-gray-200 p-3 dark:border-zinc-700">
      <div className="flex items-center justify-between gap-2">
        <p className="text-sm font-medium text-gray-900 dark:text-zinc-100">Waiting orders</p>
        <button type="button" className={ghostBtnClass} onClick={onClose}>
          Close
        </button>
      </div>
      <input
        className={`${inputClass} w-full`}
        value={query}
        placeholder="Filter serial or model"
        aria-label="Filter waiting orders"
        onChange={(event) => setQuery(event.target.value)}
      />
      {error ? <p className="text-sm text-red-700 dark:text-red-300">{error}</p> : null}
      {orders.length === 0 && !error ? (
        <p className="text-sm text-gray-600 dark:text-zinc-400">No admitted order is waiting for inspection.</p>
      ) : null}
      <ul className="max-h-64 space-y-2 overflow-y-auto">
        {shown.map((order) => (
          <li key={order.unit_id} className="text-sm text-gray-900 dark:text-zinc-100">
            <span className="inline-flex items-center gap-2">
              <span className="font-medium">{order.serial}</span>
              <button type="button" className={ghostBtnClass} disabled={busy} onClick={() => onPick(order)}>
                Use
              </button>
            </span>
            {order.model ? <span> · {order.model}</span> : null}
            {order.size ? <span> · {order.size}</span> : null}
            {order.long_serial ? <span className="block text-xs text-gray-600 dark:text-zinc-400">{order.long_serial}</span> : null}
          </li>
        ))}
      </ul>
    </div>
  );
}
